var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMoneyDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "---",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "010-Payment-History---Payment-Details",
    transform: "translate(-629.000000, -326.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(592.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-layout-copy",
    transform: "translate(30.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(7.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4458035,12.4839339 C10.0669262,12.9678653 9.59378127,13.2589985 9.02639728,13.4026294 C8.78982957,13.4517774 8.6475199,13.595447 8.69557153,13.8865608 L8.69557153,14.6616254 C8.69557153,14.9035912 8.60131349,15 8.36474578,15 L7.56079408,15 C7.32422637,15 7.22996833,14.8544431 7.22996833,14.6124774 L7.22996833,14.0321468 C7.22996833,13.5973634 7.22996833,13.5973634 6.80488455,13.5482153 C6.28367857,13.4518065 5.81054315,13.3553977 5.33740774,13.1134319 C4.95853036,12.9206143 4.95853036,12.8223181 5.05278839,12.4367022 C5.14704643,12.1455884 5.19509807,11.8563716 5.2893561,11.5652384 C5.38361414,11.2268638 5.47787218,11.1777158 5.76249152,11.3724207 C6.2836975,11.6635346 6.80301093,11.8072041 7.37039493,11.8563522 C7.74927231,11.9055003 8.08009805,11.8563522 8.41091434,11.7107953 C9.02636889,11.4196815 9.12061747,10.6937649 8.59943041,10.2590009 C8.41091434,10.113444 8.22055303,10.0170352 7.98397586,9.92062637 C7.41659187,9.67866064 6.84920788,9.48584299 6.3280019,9.14556174 C5.47597964,8.61246285 4.9566662,7.9357331 5.00284422,6.87147103 C5.05089585,5.71080982 5.71254735,4.93574519 6.80113732,4.54821288 C7.2262211,4.40265598 7.2262211,4.40265598 7.2262211,3.91871484 L7.2262211,3.43478338 C7.2262211,3.09640883 7.27427274,3 7.65130489,3 L7.98213063,3 C8.69183376,3 8.69183376,3 8.73990432,3.72589719 C8.73990432,4.25899608 8.73990432,4.25899608 9.2611103,4.35539523 C9.63998768,4.40454331 10.018884,4.54821288 10.3958783,4.69376979 C10.5843944,4.79017861 10.6804976,4.93573552 10.632446,5.12855317 C10.538188,5.46692772 10.4439299,5.75805121 10.3478267,6.09641608 C10.2535686,6.38752989 10.1593106,6.43479064 9.87469123,6.28923373 C9.30730724,5.99811993 8.69185269,5.9017111 8.07639814,5.9017111 C7.88788206,5.9017111 7.74557239,5.95085918 7.60326272,5.99811993 C7.03587872,6.24008566 6.98780817,6.8695837 7.41474664,7.25711601 C7.65131435,7.44993366 7.93595262,7.59549057 8.17252033,7.69189939 C8.64565575,7.88471704 9.11879116,8.07942202 9.59192658,8.36862914 C11.0612486,9.33837939 11.4400882,11.2249378 10.4457941,12.4839339 L10.4458035,12.4839339 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    cx: 1,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    cx: 7,
    cy: 1,
    r: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoneyDots);
export default __webpack_public_path__ + "static/media/icon-money-dots.15bd7009dc7fbd3272bcf1c94b486978.svg";
export { ForwardRef as ReactComponent };